import { queryOptions, useMutation } from '@tanstack/react-query'

import type { UnsubscribeRequest } from '../model/churn.types'
import { getSubscribeProtection, unsubscribe } from './churn.api'

export const churnEntityQueries = {
  all: ['churn'],

  // Query Keys
  getSubscribeProtectionQueryKey: ({
    subscribeMappId,
    bearerToken,
  }: {
    subscribeMappId: string
    bearerToken?: string
  }) => [...churnEntityQueries.all, 'GET_SUBSCRIBE_PROTECTION', subscribeMappId, bearerToken],
  // Query Options
  /**
   * V1 API - Get subscription protection info
   */
  getSubscribeProtection: ({ subscribeMappId, bearerToken }: { subscribeMappId: string; bearerToken?: string }) =>
    queryOptions({
      queryKey: churnEntityQueries.getSubscribeProtectionQueryKey({ subscribeMappId, bearerToken }),
      queryFn: async () => await getSubscribeProtection(subscribeMappId, bearerToken),
    }),
} as const

/**
 * Hook for unsubscribing from a subscription
 *
 * @example
 * ```tsx
 * const { mutate: unsubscribeMutation } = useUnsubscribeMutation()
 *
 * unsubscribeMutation({
 *   request: { subscribeMappId: '123', unsubsrcibeReason: 'Too expensive' },
 *   bearerToken: 'optional-token'
 * }, {
 *   onSuccess: (data) => {
 *     if (data.resultCd === '200') {
 *       console.log('Successfully unsubscribed')
 *     }
 *   }
 * })
 * ```
 */
export const useUnsubscribeMutation = () => {
  return useMutation({
    mutationFn: async ({ request, bearerToken }: { request: UnsubscribeRequest; bearerToken?: string }) =>
      await unsubscribe(request, bearerToken),
  })
}
